
export const reportColumns = [
	{
		name: 'First Name',
		selector: row => row.firstName? `${row.firstName.toUpperCase()}`: row.firstName,
		width: "140px",
		center: true
	},
	{  
		name: 'Last Name',
		selector: row => row.lastName? `${row.lastName.toUpperCase()}`: row.lastName,
		width: "140px",
		center: true
	},
	{
		name: 'MR Id',
		selector: row => row.mrId,
		width: "100px",
		center: true,
	},
	{
		name: 'Payment Amount',
		selector: row => row.paymentAmount,
		width: "160px",
		cell: row => <div style={{textAlign:'right'}}>{row.paymentAmount}</div>,
		right: true
	},
	{
		name: 'Allowance',
		selector: row => row.allowance,
		width: "120px",
		center: true

	},
	{
		name: 'Net Amount',
		selector: row => row.netAmount,
		cell: row => <div style={{textAlign:'right'}}>{row.netAmount}</div>,
		width: "120px",
		right: true
	},
	{
		name: 'Payment Code',
		selector: row => row.paymentCode,
		width: "130px",
		center: true
	},
	{
		name: 'Payment Description',
		selector: row => row.paymentDesc,
		width: "180px",
		center: true
	},
	{
		name: 'Month',
		selector: row => row.reportType ? row.reportType.split("-")[0]: row.reportType,
		width: "100px",
		center: true
	}
];

export const customReportColumns = [
	{
		name: 'First Name',
		selector: row => row.firstName? `${row.firstName.toUpperCase()}`: row.firstName,
		width: "140px",
		center: true		
	},
	{
		name: 'Last Name',
		selector: row => row.lastName? `${row.lastName.toUpperCase()}`: row.lastName,
		width: "140px",
		center: true
	},
	{
		name: 'MR Id',
		selector: row => row.mrId,
		width: "100px",
		center: true
	},
	{
		name: 'Payment Amount',
		selector: row => row.paymentAmount,
		cell: row => <div style={{textAlign:'right'}}>{row.paymentAmount}</div>,
		width: "160px",
		right: true
	},
	{
		name: 'Allowance',
		selector: row => row.allowance,
		width: "120px",
		center: true
	},
	{
		name: 'Net Amount',
		selector: row => row.netAmount,
		cell: row => <div style={{textAlign:'right'}}>{row.netAmount}</div>,
		width: "110px",
		right: true
	},
	{
		name: 'Payment Code',
		selector: row => row.paymentCode,
		width: "130px",
		center: true
	},
	{
		name: 'Payment Description',
		selector: row => row.paymentDesc,
		width: "170px",
		center: true
	},
	{
		name: 'Report Type',
		selector: row => row.reportType,
		width: "150px",
		center: true
	}
];

{/*export const csvReportColumns =[
	{
	label:"Carefacility Name",
	key:"careFacilityName"	
  },
  {
	label: 'First Name',
	key: "firstName"
  },
  {  
	label: 'Last Name',
	key: 'lastName'
  },
  {
	label: 'MR_Id',
	key: 'mrId'
},
{
	label: 'Payment Amount',
	key: 'paymentAmount'
},
{
	label: 'Allowance',
	key: 'allowance'
},
{
	label: 'Net Amount',
	key: 'netAmount'
},
{
	label: 'Payment Code',
	key: 'paymentCode'
},
{
	label: 'Payment Description',
	key: 'paymentDesc'
},
{
	label: 'Report Generated Date',
	key: 'rptGeneratedDate'
}
]*/}

export const ReportExcelColumns =[
	{
	header:"Carefacility Name",
	key:"careFacilityName"	
  },
  {
	header: 'First Name',
	key: "firstName"
  },
  {  
	header: 'Last Name',
	key: 'lastName'
  },
  {
	header: 'MR_Id',
	key: 'mrId'
},
{
	header: 'Payment Amount',
	key: 'paymentAmount'
},
{
	header: 'Allowance',
	key: 'allowance'
},
{
	header: 'Net Amount',
	key: 'netAmount'
},
{
	header: 'Payment Code',
	key: 'paymentCode'
},
{
	header: 'Payment Description',
	key: 'paymentDesc'
},
{
	header: 'Report Generated Date',
	key: 'rptGeneratedDate'
}
]